// extracted by mini-css-extract-plugin
export default {"relativeContainer":"OrgUserInput_relativeContainer__0ZIFg","field":"OrgUserInput_field__A8FBD","deleteIcon":"OrgUserInput_deleteIcon__p4PNL"};